/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
import Vue from 'vue'
import { ServerResponse } from 'http';

//import gql from 'graphql-tag';
import gql from 'graphql-tag';

const getUserQuery =   gql`
query root($token: String) {
    userFromToken(token: $token) {
        username
        first_name
        last_name
        user_id
        fullName
    } 
}
`;


const v = {
  state: {
    authorizationToken: null,
    user: {},
    selectedProduct: null,
    selectedNumber: null,
    signupEmail: null,
    signupPassword: null,
    signupGivenName: null,
    signupLastName: null,
    signupCompanyName: null,
    signupAddress1: null,
    signupAddress2: null,
    signupCity: null,
    signupProvince: null,
    signupPostal: null,
    signupCountry: 'Canada',
    signuptab: null,
  },
  getters: {
    authorizationToken: function(state) {
      state.authorizationToken = localStorage.authorizationToken;
      return state.authorizationToken;
        // return persistFetch('authorizationToken');
    },
    isLoggedIn: function(state) {
      if (state.user.user_id) {
          if (state.authorizationToken) {
            return true;
          }
      }
      return false;
    }
  },
  mutations: {
    signupEmail: function(state,val) {
      state.signupEmail = val;
    },
    signupPassword: function(state, val) {
      state.signupPassword = val;
    },
    updateAuthorizationToken: function(state,val) {
        localStorage.setItem('authorizationToken', val);
        state.authorizationToken = localStorage.getItem('authorizationToken');
        console.log('mutation: set state.authorization to ' + state.authorizationToken )
    },
    updateUser: function(state,val) {
      console.log(val);
        state.user = val;
    },
    updateUsers: function (state,val) {
      state.users = val;
    },
    updateSelectedProduct: function(state, val) {
      state.selectedProduct = val;
    },
    updateSelectedNumber: function (state, val) {
      state.selectedNumber = val;
    },
    signupGivenName: function (state, val) {
      state.signupGivenName = val;
    },
    signupLastName: function (state, val) {
      state.signupLastName = val;
    },
    signupCompanyName: function (state, val) {
      state.signupCompanyName = val;
    },
    signupAddress1: function (state, val) {
      state.signupAddress1 = val;
    },
    signupAddress2: function (state, val) {
      state.signupAddress2 = val;
    },
    signupCity: function (state, val) {
      state.signupCity = val;
    },
    signupProvince: function (state, val) {
      state.signupProvince = val;
    },
    signupPostal: function (state, val) {
      state.signupPostal = val;
    },
    signupCountry: function (state, val) {
      state.signupCountry = val;
    },
    signuptab: function (state, val) {
      state.signuptab = val;
    }
  },
  actions: {
    updateAuthorizationToken: function({commit}, val) {
      return new Promise(function(resolve, reject) {
        console.log('updateAuthorizationToken action');
        commit('updateAuthorizationToken', val); 
        resolve(true);
      });
    },
    updateUser: function({commit}, val) {
      return new Promise(function(resolve, reject) {
        commit('updateUser', val);
        console.log('user updated ');
        resolve(true);
      })
    },
    updateUsers: function({commit},val) {
      commit('updateUsers', val);
    },
    updateSelectedProduct: function({commit}, val) {
      commit('updateSelectedProduct', val);
    },
    getLoggedInUser: function({commit, state, getters}, apolloClient) {
      let self = this;
      console.log(getters.authorizationToken);
      console.log('getting user');
      if (getters.authorizationToken) {
        let variables = {
          token: localStorage.authorizationToken
        };
        apolloClient.query({query: getUserQuery, variables,fetchPolicy: 'network-only'})
        .then( function(result) {
          if (result.data.userFromToken) {
            if (result.data.userFromToken.user_id) {
              commit('updateUser', result.data.userFromToken);
            } else {
              commit('updateUser', {});
            }
          }
        });
      }
    },
  },
};

export default v;
